<div class="container-fluid" [attr.dir]="userLang === 'ar' ? 'rtl' : 'ltr'">
  <div class="row w-100 mt-3 justify-content-center ps-3 px-md-5">
    <div class="col-12 col-md-5 col-lg-7 my-auto order-md-1 order-2">
      <div class="title">
        <h4>{{ 'cvScan.title' | translate }}</h4>
      </div>
      <div class="descriptionn">
        <p>{{ 'cvScan.description' | translate }}</p>
      </div>
      <div class="mb-5">
        <button class="gradient-button scancv" (click)="scrollToSteps()">
          {{ 'cvScan.scanButton' | translate }}
        </button>
      </div>
    </div>
    <img class="col-8 col-md-7 col-lg-5 text-center p-0 order-md-2 order-1 cv-img"
      src="../../../assets/img/image_16-removebg-preview.png" />
  </div>
</div>



<app-video-tutorial
  [title]="'cvScan.videoTitle'"
  [buttonText]="'cvScan.videoButton'"
 (buttonClicked)="scrollToSteps()"
  [videoPath]="'assets/video/Scan my Cv.mp4'"
  [videoPoster]="'assets/img/Frame 2095587744.png'"
  [features]="[
    'cvScan.feature1',
    'cvScan.feature2',
    'cvScan.feature3'
  ]">
</app-video-tutorial>
<div class="scan mt-5" #stepsSection>{{ "Scan Now" | translate }}</div>
<div class="steps-wrapper my-4">
  <p-steps [model]="steps" [(activeIndex)]="activeIndex" />
</div>

<!-- Step 1: Upload Resume -->
<div class="upload-resume my-5 " *ngIf="activeIndex === 0" (dragover)="onDragOver($event)" (drop)="onCVDrop($event)">
  <img width="15%" src="../../../assets/img/upload cv.png" />
  <h3>{{ "Upload Your Resume" | translate }}</h3>
  <p>{{ "Drag and drop your resume as PDF or word file" | translate }}</p>
  <p>{{ "Or" | translate }}</p>
  <input type="file" id="uploadCv" (change)="onCVSelected($event)" accept=".pdf,.doc,.docx" #uploadCv hidden />
  <button class="button" (click)="uploadCv.click()">
    {{ "Select from Browser" | translate }}
  </button>
</div>

<!-- Step 2: Job Description Form -->
<div class="job-form my-2" *ngIf="activeIndex === 1">
  <div class="form-container">
    <div class="form-group">
      <label>{{ 'Job Title' | translate }}</label>
      <input type="text" [(ngModel)]="jobTitle" placeholder="{{ 'Enter your job title' | translate }}"
        class="form-input" />
    </div>
    <div class="form-group">
      <label>{{ 'Objective' | translate }}</label>
      <textarea [(ngModel)]="objective" placeholder="{{ 'Enter your objective' | translate }}" class="form-textarea"
        rows="4"></textarea>
    </div>
    <div class="form-btn-container">
      <button class="button next-btn" (click)="nextStep()">
        {{ 'Next' | translate }}
      </button>
    </div>
  </div>
</div>


<section class="cv-section">
  <div class="container">
    <div class="text-center">
      <h3 class="titlle">{{ 'cvCover.title' | translate }}</h3>
    </div>
    <div class="row d-flex justify-content-center align-items-center">
      <div class="col-12 col-md-7 px-md-5">
        <p class="title-bulid">{{ 'cvCover.subtitle' | translate }}</p>
        <p class="section-text">{{ 'cvCover.description' | translate }}</p>
        <div class="btn-container">
          <button class="gradient-button">{{ 'cvCover.button' | translate }}</button>
        </div>
      </div>
      <div class="col-12 col-md-5 mb-md-4 mb-0 mt-3 mx-0 mt-md-0 text-center">
        <img class="img-fluid" src="../../../assets/img/Frame_2095587929-removebg-preview.png" alt="CV Image" />
      </div>
    </div>
  </div>
</section>

<section class="services-section">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12 col-sm-6 col-md-4">
        <div class="title-card">
          <h3 class="services-main-title">
            {{ "Resume optimization checklist" | translate }}
          </h3>
          <p class="services-main-description">
            {{ "resume_checks_description" | translate }}
          </p>
        </div>
      </div>

      <app-card *ngFor="let item of services" [color]="item.color" [img]="item.img" [icon]="true" [title]="item.title"
        [description]="item.description" />
    </div>
  </div>
</section>